const settings = {
    MIDDLEWARE_BASE_URL: window.env.MIDDLEWARE_BASE_URL,
    API_URL: window.env.API_URL,
    PING_URL: window.env.PING_URL
};

export default settings;